/* ============================================================
   STICKY ANNOUNCEMENT BAR
   ============================================================ */
function setAnnouncementHeight() {
  const bar = document.querySelector('.announcement_bar');
  if (!bar) return;

  const height = bar.offsetHeight;
  document.documentElement.style.setProperty('--announcement-height', height + 'px');
}

window.addEventListener('load', setAnnouncementHeight);
window.addEventListener('resize', setAnnouncementHeight);
document.addEventListener('shopify:section:load', setAnnouncementHeight);

/* ============================================================
   ADD CTA ARROWS TO TEXT CONTENT BUTTONS
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll(`
    .feature-row__buttons .btn,
    .homepage-featured-content-box-inner .btn,
    .bottom-cta-button .btn,
    .rich-text .btn,
    .content-grid__bottom-button .btn
  `);

  buttons.forEach(button => {
    if (button.closest('.section--newsletter')) return;
    if (button.querySelector('.cta-arrow-icon')) return;

    button.insertAdjacentHTML('beforeend', `
      <svg class="cta-arrow-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M5 12H17" />
        <path d="M13 7L18 12L13 17" />
      </svg>
    `);
  });
});